// @ts-strict-ignore
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Button } from '@actual-app/components/button';
import { SvgCheck } from '@actual-app/components/icons/v2';
import { View } from '@actual-app/components/view';

import { Modal, ModalCloseButton, ModalHeader } from '#components/common/Modal';
import { useModalEnHoja } from '#components/common/modalesEnHoja';
import { BotonesHoja } from '#components/common/ModalHoja';
import { color } from '#components/mobile/ui/tokens';
import { Notes } from '#components/Notes';
import { useNotes } from '#hooks/useNotes';
import type { Modal as ModalType } from '#modals/modalsSlice';

type NotesModalProps = Extract<ModalType, { name: 'notes' }>['options'];

export function NotesModal({ id, name, onSave }: NotesModalProps) {
  const { t } = useTranslation();
  const originalNotes = useNotes(id);

  const enHoja = useModalEnHoja('notes');
  const [notes, setNotes] = useState(originalNotes);
  useEffect(() => setNotes(originalNotes), [originalNotes]);

  function _onSave() {
    if (notes !== originalNotes) {
      onSave?.(id, notes);
    }
  }

  return (
    <Modal
      name="notes"
      containerProps={{
        style: { height: '50vh' },
      }}
    >
      {({ state }) =>
        enHoja ? (
          <>
            <ModalHeader
              title={t('Notes')}
              subtitulo={name}
              icono="note"
              rightContent={<ModalCloseButton onPress={() => state.close()} />}
            />
            <Notes
              notes={notes}
              editable
              focused
              getStyle={() => ({
                borderRadius: 14,
                border: `1.5px solid ${color.line2}`,
                padding: 14,
                minHeight: 140,
                minWidth: 0,
                fontSize: 15,
                fontWeight: 500,
                lineHeight: 1.4,
                backgroundColor: color.surface,
                color: color.fg,
                marginBottom: 16,
              })}
              onChange={setNotes}
            />
            <BotonesHoja
              accion={{
                texto: t('Save note'),
                testId: 'guardar-nota',
                onPress: () => {
                  _onSave();
                  state.close();
                },
              }}
              onCancelar={() => state.close()}
            />
          </>
        ) : (
          <>
            <ModalHeader
              title={t('Notes: {{name}}', { name })}
              rightContent={<ModalCloseButton onPress={() => state.close()} />}
            />
            <View
              style={{
                flex: 1,
                flexDirection: 'column',
              }}
            >
              <Notes
                notes={notes}
                editable
                focused
                getStyle={() => ({
                  borderRadius: 6,
                  flex: 1,
                  minWidth: 0,
                })}
                onChange={setNotes}
              />
              <View
                style={{
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyItems: 'center',
                  width: '100%',
                  paddingTop: 10,
                }}
              >
                <Button
                  variant="primary"
                  style={{
                    fontSize: 17,
                    fontWeight: 400,
                    width: '100%',
                  }}
                  onPress={() => {
                    _onSave();
                    state.close();
                  }}
                >
                  <SvgCheck
                    width={17}
                    height={17}
                    style={{ paddingRight: 5 }}
                  />
                  <Trans>Save notes</Trans>
                </Button>
              </View>
            </View>
          </>
        )
      }
    </Modal>
  );
}
